import { useEffect, useState } from "react";
import { useGoogleOneTapLogin } from "@react-oauth/google";
import api from "../api";
import { useAuth } from "../auth";

/**
 * Google One Tap (auto-login): se l'utente ha una sessione Google attiva e non è loggato,
 * mostra il prompt "Continua come …" in alto a destra — un solo tocco, senza redirect.
 * Safety net per i browser che bloccano i cookie di terze parti (Safari/Firefox strict):
 * il JWT torna nel body e viene salvato in localStorage.
 * Disattivato: utente già loggato, subito dopo un logout esplicito (atlas_no_onetap),
 * durante il callback OAuth, e se il client_id non è configurato.
 */
export default function GoogleOneTap() {
  const { user } = useAuth();
  const [blocked, setBlocked] = useState(true);

  useEffect(() => {
    const off = localStorage.getItem("atlas_no_onetap") === "1"
      || window.location.pathname.startsWith("/auth/google/callback");
    setBlocked(off);
  }, []);

  useGoogleOneTapLogin({
    disabled: !!user || blocked,
    auto_select: true,
    cancel_on_tap_outside: true,
    onSuccess: async (cred) => {
      try {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const { data } = await api.post("/auth/google/token", {
          id_token: cred.credential,
          lang: (navigator.language || "en").slice(0, 2),
        });
        localStorage.removeItem("atlas_no_onetap");
        localStorage.setItem("atlas_token", data.token);
        window.location.reload();
      } catch {
        /* token rifiutato o Google non configurato: niente auto-login */
      }
    },
    onError: () => {},
  });

  return null;
}
